// @flow
import React from 'react'

const Bell = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
      <g fill="none" fillRule="evenodd" stroke="#6e7b8c">
        <path d="M11.5 4.5v-4" />
        <path
          strokeLinecap="square"
          d="M22.5 15.5c0-6.1-4.9-11-11-11s-11 4.9-11 11v3h22v-3zM4.6 14.5c.3-2 1.4-3.7 2.9-4.7M.5 22.5h22M15.5.5h-8"
        />
      </g>
    </svg>
  )
}

export default Bell



// WEBPACK FOOTER //
// ./src/components/Icons/Bell.js